import { type FC, type ReactNode, createContext, useContext } from 'react';
import { type ProjectStatusModalHandlers } from './useProjectStatusConfig.types';

const ProjectModalContext = createContext<ProjectStatusModalHandlers | null>(null);

export const ProjectModalProvider: FC<{
    children: ReactNode;
    modalHandlers: ProjectStatusModalHandlers;
}> = ({ children, modalHandlers }) => (
    <ProjectModalContext.Provider value={modalHandlers}>{children}</ProjectModalContext.Provider>
);

export const useProjectModalHandlers = (): ProjectStatusModalHandlers => {
    const context = useContext(ProjectModalContext);
    if (!context) {
        throw new Error('useProjectModalHandlers must be used within a ProjectModalProvider');
    }
    return context;
};
